import { Price, Heading, Button, RadioIcon, RadioSelectedIcon, Tag } from '../../../atoms';
import { PlanPriceBreakdown } from '../../PlanPriceBreakdown/PlanPriceBreakdown';
import type { CardSelectProps } from '../types';

type Props = Pick<
  CardSelectProps,
  | 'withCursorPointer'
  | 'optionCardSize'
  | 'value'
  | 'clickButtonToSelect'
  | 'onOptionSelect'
  | 'priceSize'
  | 'type'
  | 'buttonFullWidth'
  | 'onRemoveSms'
> & { option: CardSelectProps['options'][0]; disabled?: boolean };

export const SingleCardSelectItem = ({
  type,
  value,
  clickButtonToSelect,
  optionCardSize,
  onOptionSelect,
  priceSize,
  buttonFullWidth = false,
  option,
  disabled = false,
  onRemoveSms,
}: Props) => {
  const showDescriptions = optionCardSize === 'large';
  const dataAttrs = option?.dataAttributes ?? {};

  return (
    <>
      {type === 'payment-plan' && (
        <div className="card-select-option__radio-container">
          {option.id === value ? <RadioSelectedIcon /> : <RadioIcon />}
        </div>
      )}
      <div className="card-select-option__price-prefix-container">
        {option.value && (
          <div className="card-select-option__value-row">
            <Heading level={type === 'payment-plan' ? 'h6' : 'h3'} className="card-select-option__value">
              {option.value}
            </Heading>
            {option.secondaryTagText ? (
              <Tag className="card-select-option__secondary-tag" variant="violet">
                {option.secondaryTagText}
              </Tag>
            ) : null}
          </div>
        )}
        {option.valueSuffix && (
          <>
            <div className="card-select-option__value-suffix">{option.valueSuffix}</div>
            <span className="card-select-option__value-suffix-mobile">
              {option.valueSuffixMobile || option.valueSuffix}
            </span>
          </>
        )}
        {showDescriptions && option.topDescription && (
          <div className="card-select-option__top-description">{option.topDescription}</div>
        )}
      </div>
      {option.contactCapExceededMessage ? null : (
        <>
          {option.contactCapLabel && (
            <div className="card-select-option__contact-cap-label">{option.contactCapLabel}</div>
          )}
          {option.price && <Price {...option.price} className="card-select-option__price" sizeLength={priceSize} />}
          {option.bottomPriceLabel && (
            <div className="card-select-option__bottom-price-label">{option.bottomPriceLabel}</div>
          )}
          {option.priceBreakdown && <PlanPriceBreakdown breakdown={option.priceBreakdown} onRemoveSms={onRemoveSms} />}
        </>
      )}
      {showDescriptions && option.bottomDescription && (
        <div className="card-select-option__price-suffix-container">
          {showDescriptions && option.bottomDescription && (
            <div className="card-select-option__bottom-description">{option.bottomDescription}</div>
          )}
        </div>
      )}
      {option.contactCapExceededMessage && (
        <div className="card-select-option__contact-cap-exceeded">{option.contactCapExceededMessage}</div>
      )}
      {!option.contactCapExceededMessage && option.buttonText && (
        <Button
          className="card-select-button"
          fullWidth={buttonFullWidth}
          readonly={!clickButtonToSelect}
          variant={option.buttonType}
          disabled={disabled}
          onClick={() => {
            if (clickButtonToSelect && !option.disabled) {
              onOptionSelect(option.id);
            }
          }}
          {...dataAttrs}
        >
          {option.buttonText}
        </Button>
      )}
    </>
  );
};
